export enum UserStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  DELETED = 'DELETED',
  SYSTEM = 'SYSTEM',
  OSP_CONNECTOR = 'OSP_CONNECTOR',
  BRZ_CONNECTOR = 'BRZ_CONNECTOR',
  UNKNOWN = 'UNKNOWN'
}
